module.exports = __webpack_public_path__ + "img/vg.e1c461f.svg";